import { FormControlLabel, Switch } from "@mui/material";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";
import { useFiltersWithContext } from "../filter-context/useFiltersWithContext";
import { useTranslation } from "../../../hooks/useTranslation";

type SwitchFilterProps = {
  name: string;
  labelKey: string;
  customValue?: unknown;
  operator?: "eq" | "null";
};

export const SwitchFilter = (props: SwitchFilterProps) => {
  const { name, labelKey, customValue, operator = "eq" } = props;
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const { getFilterValue, setFilter, deleteFilter } = useFiltersWithContext();
  const { translate } = useTranslation();

  const getValue = () => {
    if (customValue !== undefined) return customValue;
    return true;
  };

  const isChecked = (value: unknown) => {
    if (customValue !== undefined) return value === customValue;
    return value === true;
  };

  const handleChecked = (filterName: string) => {
    setFilter({
      field: filterName,
      value: getValue(),
      labelInfo: {
        descriptionKey: labelKey,
      },
      operator: operator,
    });
  };

  const handleUnchecked = (filterName: string) => {
    deleteFilter(filterName, operator);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={isChecked(getFilterValue(name, operator))}
          onChange={(_, checked) =>
            checked ? handleChecked(name) : handleUnchecked(name)
          }
        />
      }
      label={translate(labelKey, { market: selectedCountry?.countryName })}
    />
  );
};
